module.exports = __webpack_public_path__ + "img/Span-03.a84d0452.jpg";